export const ROLES = {
    SUPERADMIN: "SUPERADMIN",
    BOTS_OPS: "BOTS_OPS",
    ADMIN_COMERCIAL: "ADMIN_COMERCIAL",
    POSTVENTA: "POSTVENTA",
};
export const PERMISSIONS = [
    "company.read",
    "company.write",
    "company.note.write",
    "user.read",
    "user.write",
    "user.reset_password",
    "session.read",
    "session.kill",
    "channel.read",
    "channel.restart",
    "channel.write",
    "template.read",
    "template.sync",
    "template.pause",
    "template.cancel_scheduled",
    "dlr.read",
    "dlr.export",
    "agent.read",
    "agent.move_company",
    "dashboard.read",
    "reporting.read",
    "reporting.refresh",
    "audit.read",
    "feature_flag.write",
    "holiday.write",
    "webchat.read",
    "webchat.write",
];
//# sourceMappingURL=roles.js.map